import ActionDocumentReferenceDrawer from './ActionDocumentReferenceDrawer.vue';
import DocumentFieldDetailsDrawer from './DocumentFieldDetailsDrawer.vue';

export default {
	ActionDocumentReferenceDrawer,
	DocumentFieldDetailsDrawer,
};
